/**
 * Interleaves given iterables, until one of them is consumed.
 *
 * @param args interables to be interleaved
 */
export default function *(...args) {
    if (args.length === 1) {
        yield* args[0][Symbol.iterator]();
    } else {
        const iterators = args.map(arg => arg[Symbol.iterator]());
        let index = 0;
        let currentResult;
        let nextResult = iterators[0].next();

        while (true) {
            currentResult = nextResult;
            index = (index + 1) % iterators.length;
            nextResult = iterators[index].next();

            yield currentResult.value;

            if (nextResult.done) {
                return;
            }
        }
    }
}
